/* ==========================================================================
   OASIS — Consultation components behaviour
   · Validates the callback form before the Google Sheets mirror sees the
     submit (document capture phase), and blocks double submits.
   · Links carrying data-opr-concern ("Discuss in confidence") pre-select the
     concern in the target callback form and move focus into it.
   Loaded by snippets/oasis-callback-form.liquid; safe to include twice.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__oprConsultation) return;
  window.__oprConsultation = true;

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setEmailState(input, valid) {
    var error = document.getElementById(input.getAttribute('data-error-id'));
    input.setAttribute('aria-invalid', valid ? 'false' : 'true');
    if (!error) return;
    error.hidden = valid;
    if (valid) {
      input.removeAttribute('aria-describedby');
    } else {
      input.setAttribute('aria-describedby', error.id);
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('[data-opr-callback]')) return;

      var email = form.querySelector('input[type="email"]');
      if (email && !EMAIL.test(email.value.trim())) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setEmailState(email, false);
        email.focus();
        return;
      }

      var button = form.querySelector('.opr-cbf__submit');
      if (!button) return;
      if (button.getAttribute('aria-busy') === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      button.setAttribute('aria-busy', 'true');
      var busyLabel = button.getAttribute('data-busy-label');
      var span = button.querySelector('span');
      if (busyLabel && span) span.textContent = busyLabel;
    },
    true
  );

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-opr-callback] input[type="email"]')) return;
    if (input.getAttribute('aria-invalid') === 'true' && EMAIL.test(input.value.trim())) {
      setEmailState(input, true);
    }
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-opr-concern]');
    if (!trigger) return;

    var hash = (trigger.getAttribute('href') || '').split('#')[1];
    var target = hash ? document.getElementById(hash) : null;
    var form = target && target.querySelector('form[data-opr-callback]');
    if (!form) return; // no live form (e.g. already sent): let the anchor behave normally

    event.preventDefault();

    var concern = (trigger.getAttribute('data-opr-concern') || '').trim().toLowerCase();
    var select = form.querySelector('select');
    if (select && concern) {
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].text.trim().toLowerCase() === concern) {
          select.selectedIndex = i;
          break;
        }
      }
      var wrap = select.closest('.opr-cbf__select');
      if (wrap) {
        wrap.classList.remove('is-prefilled');
        void wrap.offsetWidth;
        wrap.classList.add('is-prefilled');
      }
    }

    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });

    var first = form.querySelector('input[type="text"], input[type="email"]');
    if (first) {
      window.setTimeout(function () {
        first.focus({ preventScroll: true });
      }, reduceMotion ? 0 : 700);
    }
  });

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // After Shopify's redirect (?contact_posted=true) move screen-reader focus to the confirmation.
  if (/[?&]contact_posted=true/.test(window.location.search)) {
    onReady(function () {
      var done = document.querySelector('.opr-cbf__done');
      if (done) done.focus({ preventScroll: true });
    });
  }

  // Keep the sitewide floating pills (snippets/oasis-floating-widgets) off a form in view,
  // where on mobile they would sit over the submit button.
  onReady(function () {
    var forms = document.querySelectorAll('.opr-cbf');
    if (!forms.length || !('IntersectionObserver' in window)) return;

    var inView = [];
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var index = inView.indexOf(entry.target);
          if (entry.isIntersecting && index === -1) inView.push(entry.target);
          if (!entry.isIntersecting && index !== -1) inView.splice(index, 1);
        });
        document.documentElement.classList.toggle('opr-cbf-in-view', inView.length > 0);
      },
      { threshold: 0.15 }
    );

    forms.forEach(function (form) {
      observer.observe(form);
    });
  });
})();
